<script>

    
    export let settings = null

    let isSet = "backdrop-filter" in settings.style && settings.style["backdrop-filter"] != "unset"
    
    $: {
        if (isSet) {
            settings.style["backdrop-filter"] = "blur(8px)"
            settings.style["-webkit-backdrop-filter"] = "blur(8px)"
        } else {
            settings.style["backdrop-filter"] = "unset"
            settings.style["-webkit-backdrop-filter"] = "unset"
        }
    }
    
    </script>
    
    <div class="input-wrap">

        <input type="checkbox" bind:checked={isSet}/>
    </div>
    
    
    <style>
    
    .input-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
        
    input {
        outline: none;
        border: none;
        margin: 0px;
        padding: 0px;
        margin-left: 10px;
    }
    
    </style>